import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { ReportView } from "@/features/subjects/components/SubjectReportView";

export const Route = createLazyFileRoute("/_auth/_app/subjects/$id/report")({
  component: memo(() => {
    const { reportId } = Route.useSearch();
    return <ReportView reportId={reportId} />;
  }),
});
